module.exports = __webpack_public_path__ + "media/1678779171725-jwprOaEf.770222d8.mp4";